import React, { useState, useEffect } from 'react';
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import BuildAccordion from './BuildAccordion';
import BuildTab from './BuildTab2';
import { IoClose } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { MdBookmarkAdd } from "react-icons/md";
import { useParams } from "react-router-dom";
import { getbuildsheet, getbuildsheetdata, addbuildsheet } from "../../Api/buildsheetApi"
import { getsinglebuildStations, upatebuildStationStatus, upatebuildStatus, assignpickupstation } from "../../Api/Buildstationsapi"
import { getCurrentUser } from "../../Api/auth";
import DriverWood from "./DriverWood";
import Hybrid from "./Hybrid";
import IronWedge from "./IronWedge";
import Wedge from "./Wedge";
import Putter from "./Putter";
import { ShippingStGet } from '../../Api/ShippingSt';
import { getbuildStationsfilter, dropdownfilter, getbuilderlist, pickUpdownfilter } from '../../Api/Buildstationsapi'
import { useHistory } from 'react-router-dom';
import { IoCloseSharp } from "react-icons/io5";
import Spinner from 'react-bootstrap/Spinner';
import { Link } from "react-router-dom";
import BuildStationLeft from './BuildStationLeft';
import BuildTabBuildStation from './BuildTabBuildStation';
import { getInventoryByTypeWithShaftAndGrip, getallModeldatabymake, getInventoryByType } from "../../Api/inventoryApi";
import { getremoteInquirydataApi } from "../../Api/iron"
import { getNonEmptyStations } from '../../Api/StagingStationsApi';
import { getsingleprescription } from "../../Api/iron"
import { getPrescription } from "../../Api/prescriptionApis";
import BuildsheetInsights from "./BuildsheetInsights";

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};


const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

function BuildStation() {

    const history = useHistory();

    const [showinsight, setShowinsight] = useState(false);

    const closeButton = () => {
        setShowinsight(false);
    }

    const goBack = () => {
        history.goBack();
    };

    const params = useParams();
    const id = params.id;

    const [scrolled, setScrolled] = useState(false);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [buildsheetdata, setBuildSheetData] = useState([]);
    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [buildApiCall, setBuildApiCall] = useState(0);
    const [apicallupate, setApicallUpate] = useState(false);
    const [errors, setErrors] = useState([]);
    const [BuildStation, setBuildStation] = useState(0);
    const [userdata, setUserdata] = useState('');
    const [BuildStations, setBuildStations] = useState([]);
    const [PickUpStations, setPickUpStations] = useState([]);


    useEffect(() => {
        getBuildStationdata();
        getDataById();
        getbuildSheetDataById();
        getallModels();
        buildStGets();
        getallmakedata(0);
    }, []);



    const [selectedButtons, setSelectedButtons] = useState([]);
    const [buildstatus3, setBuildstatus3] = useState(false);


    const [show01, setShow01] = useState(false);

    const handleClose01 = () => setShow01(false);
    const handleShow01 = () => setShow01(true);

    const [show3, setShow3] = useState(false);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [show4, setShow4] = useState(false);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    const [show5, setShow5] = useState(false);

    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);

    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);
    const [closePopup, setClosePopup] = useState('');


    const [buttonNames, setButtonNames] = useState([
        { id: 1, name: "Driver" },
        { id: 2, name: "3 Wood" },
        { id: 2, name: "4 Wood" },
        { id: 2, name: "5 Wood" },
        { id: 2, name: "7 Wood" },
        { id: 2, name: "9 Wood" },
        { id: 3, name: "2 Hybrid" },
        { id: 3, name: "3 Hybrid" },
        { id: 3, name: "4 Hybrid" },
        { id: 3, name: "5 Hybrid" },
        { id: 3, name: "6 Hybrid" },
        { id: 3, name: "7 Hybrid" },
        { id: 3, name: "8 Hybrid" },
        { id: 4, name: "1 Iron" },
        { id: 4, name: "2 Iron" },
        { id: 4, name: "3 Iron" },
        { id: 4, name: "4 Iron" },
        { id: 4, name: "5 Iron" },
        { id: 4, name: "6 Iron" },
        { id: 4, name: "7 Iron" },
        { id: 4, name: "8 Iron" },
        { id: 4, name: "9 Iron" },
        { id: 4, name: "PW" },
        { id: 5, name: "GW" },
        { id: 5, name: "SW" },
        { id: 5, name: "LW" },
        { id: 6, name: "Putter" }
    ]);


    const handleButtonClick = (index, name) => {
        if (selectedButtons.includes(index)) {
            setSelectedButtons(selectedButtons.filter(i => i !== index));
        } else {
            setSelectedButtons([...selectedButtons, index]);
        }

        setButtonNames(buttonNames.filter((_, i) => i !== index));

        const data = {
            builsheetnumber: name,
            project_id: id
        }

        addbuildsheet(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleClose();
                getDataById();
                getbuildSheetDataById();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Assigned');
    const [selectedOptionsId, setselectedOptionsId] = useState('');
    const [selectedOptionsIdFromBd, setselectedOptionsIdFromBd] = useState('');


    const [isOpen2, setIsOpen2] = useState(false);
    const [selectedOption2, setSelectedOption2] = useState('No Builder');
    const [selectedBuilderid, setSelectedBuilderid] = useState('');
    const [Builderid, setBuilderid] = useState(false);
    const [selectOptionnumber, setSelectOptionnumber] = useState(0);
    const [type_id, setType_id] = useState(0);
    const [makedata, setMakeData] = useState([]);

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };

    const closeDropdown2 = () => {
        setIsOpen2(false);
    };

    const selectOption2 = (option) => {
        setSelectedOption2(option.text);
        setSelectedBuilderid(option._id);
    };


    const [options2, setOptions2] = useState([
        { text: 'No Builder', _id: "0" },
    ]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };

    const selectOption = (option) => {
        setSelectedOption(option.text);
        setselectedOptionsId(option.number)
        setSelectOptionnumber(option.number);
    };

    const [options, setOptions] = useState([
        { text: 'Assigned', color: 'orange', number: "501" },
        { text: 'Building', color: 'yellow', number: '502' },
        { text: 'Complete', color: 'green', number: '503' },
        { text: 'Verified', color: 'blue', number: '504' }
    ]);

    const [buildsts, setbuildsts] = useState();

    const buildStGets = () => {
        ShippingStGet()
            .then((res) => {
                const Data = res.data.data;
                setbuildsts(Data)
                // if (BuildStations) {
                //     const stationStatusArray = BuildStations.map(build => Number(build.station_Id));
                //     console.log("Station Status Array:", stationStatusArray);

                //     const filteredStatusDropdown = Data.filter(
                //         station => !stationStatusArray.includes(Number(station.Shipping_Stations_id))
                //     );
                //     const newOptions = filteredStatusDropdown.map(station => ({
                //         text: station.Shipping_Stations_name,
                //         number: Number(station.Shipping_Stations_id),
                //         color: 'white'
                //     }));
                //     setOptions(prevOptions => [
                //         { text: 'Assigned', color: 'orange', number: "501" },
                //         { text: 'Building', color: 'yellow', number: '502' },
                //         { text: 'Complete', color: 'green', number: '503' },
                //         { text: 'Verified', color: 'blue', number: '504' },
                //         ...newOptions
                //     ]);
                // }
            })
            .catch((err) => {
                alert(err);
            });
    }

    //Old Code for Dropdown Shipping stations
    // useEffect(() => {
    //     if (BuildStations && Array.isArray(buildsts) && buildsts.length > 0) {
    //         const stationStatusArray = BuildStations.map(build => Number(build.station_Id));

    //         const filteredStatusDropdown = buildsts.filter(
    //             station => !stationStatusArray.includes(Number(station.Shipping_Stations_id))
    //         );
    //         const newOptions = filteredStatusDropdown.map(station => ({
    //             text: station.Shipping_Stations_name,
    //             number: Number(station.Shipping_Stations_id),
    //             color: 'white'
    //         }));

    //         setOptions(prevOptions => [
    //             { text: 'Assigned', color: 'orange', number: "501" },
    //             { text: 'Building', color: 'yellow', number: '502' },
    //             { text: 'Complete', color: 'green', number: '503' },
    //             { text: 'Verified', color: 'blue', number: '504' },
    //             ...newOptions
    //         ]);
    //     }
    // }, [buildsts, BuildStations]);


    const PicupStations = [
        {
            id: 1,
            Pickup_Stations_name: "Pick Up Station",
        },
        {
            id: 2,
            Pickup_Stations_name: "Pick Up Station",
        },
        {
            id: 3,
            Pickup_Stations_name: "Pick Up Station",
        },

    ]


    const getDataById = () => {
        getbuildsheet({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetNumber(Data);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const getbilderdata = () => {
        getbuilderlist({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                const newOptions = Data.map(builder => ({
                    text: builder.fullname,
                    _id: builder._id,
                }));
                setOptions2(prevOptions => [
                    { text: 'No Builder', _id: "0" },
                    ...newOptions
                ]);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const getBuildStationdata = () => {
        getsinglebuildStations({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildStation(Data);
                setSelectedOption(Data.shipping_station_name);
                setselectedOptionsId(Data.shipping_station_Id);
                setselectedOptionsIdFromBd(Data.shipping_station_Id);
                setSelectedOption2(Data.builder_status);
                if (Data.builder_id === "0") {
                    setBuilderid(false);
                } else {
                    setBuilderid(true);
                }
                if (Data.shipping_station_Id == '501' || Data.shipping_station_Id == '502' || Data.shipping_station_Id == '503' || Data.shipping_station_Id == '504') {
                    setBuildstatus3(false);
                } else {
                    setBuildstatus3(true);
                }
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const getbuildSheetDataById = () => {
        getbuildsheetdata({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetData(Data);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        if (buildApiCall !== 0) {
            getbuildSheetDataById();
        }
    }, [buildApiCall])


    const handleupateprojectstatus = () => {
        setApicallUpate(true);
        const data = {
            'status': (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') ? '0' : '1',
            'id': BuildStation._id,
            'project_id': params.id,
            "user_id": userdata._id,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
            "shipping_station_Id": selectedOptionsId,
            "shipping_station_name": selectedOption,
        }
        upatebuildStationStatus(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                getDataById();
                getBuildStationdata();
                closeDropdown();
                // window.location.reload();
                if (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') {
                    window.location.reload();
                } else {
                    window.location.href = `/project/ship-station/shipstation-view/${params.id}`
                }
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const handleassignpickupstation = () => {
        setApicallUpate(true);
        const data = {
            'status': (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') ? '0' : '1',
            'id': BuildStation._id,
            'project_id': params.id,
            "user_id": userdata._id,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
            "shipping_station_Id": selectedOptionsId,
            "shipping_station_name": selectedOption,
        }
        assignpickupstation(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                getDataById();
                getBuildStationdata();
                closeDropdown();
                // window.location.reload();
                if (selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504') {
                    window.location.reload();
                } else {
                    window.location.href = `/project/pickup-station/pickup-view/${params.id}`
                }
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const handleupatebuilderstatus = () => {
        setApicallUpate(true);
        const data = {
            'status': selectedOption2,
            'id': BuildStation._id,
            'project_id': params.id,
            "builder_id": selectedBuilderid,
            "fitter_name": userdata.firstname + " " + userdata.lastname,
        }
        upatebuildStatus(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                getDataById();
                getBuildStationdata();
                closeDropdown2();
                window.location.reload();
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    useEffect(() => {
        getNonEmptyStagingStations();
        getbilderdata();
        getprescriptionDataById();
        const getCurrentUserdata = getCurrentUser();
        getRemortFittingDataById();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

        dropdownfilter().then((response) => {
            if (!response.data.status) {
                setErrors(response.data.error);
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setBuildStations(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });


        pickUpdownfilter().then((response) => {
            if (!response.data.status) {
                setErrors(response.data.error);
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setPickUpStations(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });

        getprescriptiondata();
        window.scrollTo(0, 0);

    }, []);

    const [titleModel, settitleModel] = useState("")

    const handleShowBtn = (index, name) => {

        var showname = "";
        let parts = name.split(" ");
        if (parts.length > 1) {
            showname = parts[1];
        } else {
            showname = parts[0];
        }

        settitleModel(name);

        if (showname === "Driver" || showname === "Wood") {
            handleShow01();
        }

        if (showname === "Hybrid") {
            handleShow3();
        }

        if (showname === "Iron" || showname === "Wedge" || showname === "PW") {
            handleShow4();
        }

        if (showname === "Putter") {
            handleShow6();
        }

        if (showname === "GW" || showname === "SW" || showname === "LW") {
            handleShow5();
        }
        handleClose();
    };

    useEffect(() => {
        if (closePopup === "driver&Wood") {
            handleClose01();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Hybrid") {
            handleClose3();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Iron&Wedge") {
            handleClose4();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Wedge") {
            handleClose5();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Putter") {
            handleClose6();
            getDataById();
            getbuildSheetDataById();
        }

        setClosePopup('');

    }, [closePopup])


    const getColorClass = () => {
        const selectedColor = options.find(opt => opt.text === selectedOption)?.color;
        return selectedColor ? `${selectedColor}` : 'white';
    };
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);


    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByTypeWithShaftAndGrip(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setMakeData(data.makeData);
                setShaftData(data.shaftdata);
                setGripData(data.gripdata);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [allmodels, setAllModels] = useState([]);

    const getallModels = () => {
        getallModeldatabymake().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setAllModels(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }


    const [remortFittingFormData, setRemortFittingFormData] = useState(initData);
    const [deliveryType, setDeliveryType] = useState(0);


    const getRemortFittingDataById = () => {
        getremoteInquirydataApi({ id: id }).then((res) => {
            console.log("call api", "1");
            if (res?.code === 200) {
                const userData = res.data.data;
                setRemortFittingFormData(userData);
                setDeliveryType(res.data.data.delivery_type)
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
    }, [remortFittingFormData]);


    const [nonEmptyStagingStation, setNonEmptyStagingStation] = useState([]);

    const getNonEmptyStagingStations = async () => {
        return getNonEmptyStations()
            .then((response) => {
                if (!response.data.status) {
                    setErrors(response.data.error);

                } else {
                    const Data = response.data.data;
                    setNonEmptyStagingStation(Data);
                }
            }).catch((err) => {
                console.error(err);
            }).finally(() => {
                // Optionally do something finally
            });
    };

    const [allMakeData, setallMakeData] = useState([]);
    const getallmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByType(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setallMakeData(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [SinglePrescription, setSinglePrescription] = useState(0);
    const getprescriptionDataById = () => {
        getsingleprescription({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const prescriptionData = res.data.data;
                setSinglePrescription(prescriptionData);
            } else {
                // alert(res.data?.message);
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const [prescription, setPrescription] = useState(initialPrescriptionState);

    const getprescriptiondata = () => {
        const data = {
            'project_id': id
        }
        getPrescription(data).then((res) => {
            if (!res.data.status) {
                console.log(res.data.data[0].detail);
            } else {
                setPrescription(res.data.data);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    // const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    useEffect(() => {
        if (BuildStations && Array.isArray(buildsts) && buildsts.length > 0 && PickUpStations && Array.isArray(PickUpStations)) {
            if (deliveryType === 2) {
                const stationStatusArray = BuildStations.map(build => Number(build.station_Id));

                const filteredStatusDropdown = buildsts.filter(
                    station => !stationStatusArray.includes(Number(station.Shipping_Stations_id))
                );
                const newOptions = filteredStatusDropdown.map(station => ({
                    text: station.Shipping_Stations_name,
                    number: Number(station.Shipping_Stations_id),
                    color: 'white'
                }));

                setOptions(prevOptions => [
                    { text: 'Assigned', color: 'orange', number: "501" },
                    { text: 'Building', color: 'yellow', number: '502' },
                    { text: 'Complete', color: 'green', number: '503' },
                    { text: 'Verified', color: 'blue', number: '504' },
                    ...newOptions
                ]);
            }
            else if (deliveryType === 1) {
                const stationStatusArray = PickUpStations.map(build => Number(build.station_Id));
                const filteredStatusDropdown = PicupStations.filter(
                    station => !stationStatusArray.includes(Number(station.id))
                );

                const newOptions = filteredStatusDropdown.map(station => ({
                    text: station.Pickup_Stations_name,
                    number: Number(station.id),
                    color: 'white'
                }));

                setOptions(prevOptions => [
                    { text: 'Assigned', color: 'orange', number: "501" },
                    { text: 'Building', color: 'yellow', number: '502' },
                    { text: 'Complete', color: 'green', number: '503' },
                    { text: 'Verified', color: 'blue', number: '504' },
                    ...newOptions
                ]);
            } else {
                const stationStatusArray = BuildStations.map(build => Number(build.station_Id));

                const filteredStatusDropdown = buildsts.filter(
                    station => !stationStatusArray.includes(Number(station.Shipping_Stations_id))
                );
                const newOptions = filteredStatusDropdown.map(station => ({
                    text: station.Shipping_Stations_name,
                    number: Number(station.Shipping_Stations_id),
                    color: 'white'
                }));

                setOptions(prevOptions => [
                    { text: 'Assigned', color: 'orange', number: "501" },
                    { text: 'Building', color: 'yellow', number: '502' },
                    { text: 'Complete', color: 'green', number: '503' },
                    { text: 'Verified', color: 'blue', number: '504' },
                    ...newOptions
                ]);
            }
        }
    }, [buildsts, BuildStations, deliveryType, PickUpStations]);

    return (
        <>
            {
                remortFittingFormData.firstname != "" ? (
                    <>

                        <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">Add Club</h3>
                                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className='modal-select-btn'>
                                    <div className='select-btn-list'>
                                        {buttonNames.map((item) => (
                                            <div className='select-btn-item' key={item.id}>
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary btn-select ${selectedButtons.includes(item.id) ? 'selected' : ''}`}
                                                    // onClick={() => handleButtonClick(index, name)}
                                                    onClick={() => {
                                                        handleShowBtn(item.id, item.name);
                                                        getmakedata(item.id);
                                                        setType_id(item.id);
                                                    }
                                                    }
                                                >
                                                    {item.name}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>

                        {
                            showinsight === true ? (
                                <>
                                    <BuildsheetInsights id={id} closeButton={closeButton} />
                                </>
                            ) : (
                                <>


                                    <div className='design_show_mobile'>
                                        <div className='fixed-btn'>
                                            <button onClick={handleShow} disabled={selectedOption !== 'Assigned' && selectedOption !== 'Building' && selectedOption !== 'Complete' && selectedOption !== 'Verified'}>
                                                {/* <button onClick={handleShow}> */}
                                                <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="64.000000pt" height="64.000000pt" viewBox="0 0 64.000000 64.000000" preserveAspectRatio="xMidYMid meet">

                                                    <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                                                        <path d="M586 628 c-3 -7 -15 -76 -27 -153 -12 -77 -25 -143 -28 -147 -3 -4 -87 11 -186 32 -207 45 -228 47 -274 22 -55 -29 -71 -71 -71 -182 0 -108 15 -145 72 -180 28 -17 51 -20 159 -20 142 0 193 12 252 61 62 51 77 94 118 338 21 124 38 226 36 227 -14 11 -48 13 -51 2z m-301 -367 c124 -27 130 -29 127 -51 -1 -13 -4 -25 -6 -27 -2 -2 -155 29 -253 52 -22 5 -31 33 -16 48 8 9 -3 11 148 -22z m-67 -97 c76 -16 82 -18 76 -38 -4 -12 -8 -23 -10 -25 -2 -2 -44 4 -94 15 -68 13 -89 21 -85 32 3 7 5 18 5 23 0 12 12 12 108 -7z" />
                                                    </g>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="buildsheetfix dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard">
                                        <div className="main-container">
                                            <div className="main-page-body-content">
                                                <div className="main-page-body-content-body">
                                                    <div className="main-page-body-content-body-container">
                                                        <div className="container-fluid">
                                                            <div className="sec-header-new">
                                                                <button type="button" className="btn-header-transparent">
                                                                    <div className="border_box_view">
                                                                        <div className="border_box_view_inner">
                                                                            <div className="box_icon">
                                                                                <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd"><path d="m15.2752 2c-4.0003 0-7.61569 2.38397-9.19148 6.06081l-4.08372 9.52869v24.4105c0 6.6274 5.37258 12 12 12h14.7613c-1.1303-2.4315-1.7613-5.142-1.7613-8 0-10.4934 8.5066-19 19-19 2.858 0 5.5685.631 8 1.7613v-11.1718l-4.0837-9.52869c-1.5758-3.67684-5.1912-6.06081-9.1915-6.06081zm-5.5149 7.63648c.9455-2.2061 3.1147-3.63648 5.5149-3.63648h10.7248v10h-18.96692zm20.2397 6.36352v-10h10.7248c2.4002 0 4.5694 1.43038 5.5149 3.63649l2.7272 6.36351zm-13 25c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.1046 0-2-.8954-2-2s.8954-2 2-2z" /><path d="m30 46c0-8.8366 7.1634-16 16-16s16 7.1634 16 16-7.1634 16-16 16-16-7.1634-16-16zm24 0c0 1.1046-.8954 2-2 2h-4v4c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4h-4c-1.1046 0-2-.8954-2-2s.8954-2 2-2h4v-4c0-1.1046.8954-2 2-2s2 .8954 2 2v4h4c1.1046 0 2 .8954 2 2z" /></g></svg>
                                                                            </div>
                                                                            <div className="box_text_content">
                                                                                {/* <div className="big_text">Build Station {getbuildStationNumber(BuildStation.station_name)}</div> */}
                                                                                <div className="big_text">Build Station {BuildStation.station_Id}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </button>
                                                                <div className="header-left">

                                                                    <button type="button" className="btn-header-transparent me-3" onClick={() => {
                                                                        setShowinsight(true);
                                                                    }}>
                                                                        <div className="border_box_view">
                                                                            <div className="border_box_view_inner">
                                                                                <div className="box_icon">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" fill='#99ea24'><path d="m141 201h110v30h-110z" /><path d="m281 321h30v30h-30z" /><path d="m281 381h30v30h-30z" /><path d="m141 261h110v30h-110z" /><path d="m141 381h110v30h-110z" /><path d="m281 261h30v30h-30z" /><path d="m141 321h110v30h-110z" /><path d="m341 261h30v30h-30z" /><path d="m341 201h30v30h-30z" /><path d="m341 381h30v30h-30z" /><path d="m341 321h30v30h-30z" /><path d="m281 201h30v30h-30z" /><path d="m351 8.783v91.217h91.211z" /><path d="m336 130c-8.284 0-15-6.716-15-15v-115h-215c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-337zm65 296c0 8.284-6.716 15-15 15h-260c-8.284 0-15-6.716-15-15v-240c0-8.284 6.716-15 15-15h260c8.284 0 15 6.716 15 15z" /></svg>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </button>


                                                                    <Link to={`/project/project-view/${params.id}`}>
                                                                        <button type="button" className="btn-header-transparent me-3">
                                                                            <div className="border_box_view">
                                                                                <div className="border_box_view_inner">
                                                                                    <div className="box_icon">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" fill-rule="evenodd" height="512" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" width="512"><g id="Icon" fill='#99ea24'><path d="m15.479 22.75h-11.479c-.729 0-1.429-.29-1.945-.805-.515-.516-.805-1.216-.805-1.945v-16c0-.729.29-1.429.805-1.945.516-.515 1.216-.805 1.945-.805h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237v4.151c-.687-.101-1.386-.084-2.068.05-.575.112-1.055.505-1.28 1.046l-.17.41c-.224-.029-.441-.057-.441-.057-.581-.076-1.161.143-1.546.585-.521.598-.922 1.291-1.179 2.042-.19.554-.09 1.166.266 1.631l.271.353c-.137.179-.271.353-.271.353-.356.465-.456 1.077-.266 1.631.257.751.658 1.444 1.179 2.042.385.442.965.661 1.546.585l.441-.057c.086.208.17.41.17.41.023.055.049.109.077.161zm-9.979-8h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75zm7-11.75v3.5c0 .552.448 1 1 1h3.5zm-7 8.25h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-8c-.414 0-.75.336-.75.75s.336.75.75.75zm0 7h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75z" /><path d="m19.396 13.044s.355.855.354.855c.135.068.266.144.393.226l.918-.12c.248-.032.497.062.662.251.436.5.771 1.081.987 1.709.081.237.038.5-.115.699 0 0-.562.735-.562.734.008.151.008.303 0 .453l.562.735c.153.199.196.462.115.699-.216.628-.551 1.209-.987 1.709-.165.189-.414.283-.662.251 0 0-.918-.12-.917-.121-.127.083-.259.159-.393.227l-.355.855c-.096.232-.302.4-.548.448-.652.128-1.322.128-1.974 0-.246-.048-.452-.216-.548-.448 0 0-.355-.855-.354-.855-.135-.068-.267-.144-.393-.226l-.918.12c-.249.032-.497-.062-.662-.251-.437-.5-.772-1.081-.987-1.709-.081-.237-.038-.5.114-.699 0 0 .563-.735.563-.734-.008-.151-.008-.303 0-.453l-.563-.735c-.152-.199-.195-.462-.114-.699.215-.628.55-1.209.987-1.709.165-.189.413-.283.662-.251 0 0 .918.12.917.121.127-.083.258-.159.393-.227l.355-.855c.096-.232.302-.4.548-.448.652-.128 1.322-.128 1.974 0 .246.048.452.216.548.448zm-1.535 3.081c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5z" /></g></svg>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </button>
                                                                    </Link>
                                                                    <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                                        <div className="border_box_view">
                                                                            <div className="border_box_view_inner">
                                                                                <div className="box_icon">
                                                                                    <IoCloseSharp />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="dashboard-sec">
                                                                <div className="row">
                                                                    <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col design_hide_mobile">
                                                                        <BuildAccordion buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} selectedOptions={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                                                    </div>
                                                                    <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                                        <div className="fix_sec_view container-fluid ps-0">
                                                                            <div className="btn-box-section mt-0 design_hide_mobile">
                                                                                <button className="btn btn-primary btn-create" onClick={handleShow} disabled={selectedOption !== 'Assigned' && selectedOption !== 'Building' && selectedOption !== 'Complete' && selectedOption !== 'Verified'}>Add Club</button>
                                                                            </div>
                                                                            {
                                                                                deliveryType === 1 && <>
                                                                                    <div className='select-dropdown-build'>
                                                                                        <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}>
                                                                                            <div className='select-option-inner' onClick={!buildstatus3 ? toggleDropdown : null}>
                                                                                                <div className='select-options-icon'>
                                                                                                    <span className={`icon-color color-${getColorClass()}`}>{selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504' ? '' : selectedOptionsId}</span>
                                                                                                </div>
                                                                                                <div className='selected-option-text'>{selectedOption}</div>
                                                                                                <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                                    <i className="bi bi-chevron-down" />
                                                                                                </span>
                                                                                            </div>

                                                                                            {isOpen && (
                                                                                                <div className='option-list buildsheet-option-list'>
                                                                                                    <div className='drop-down-list'>
                                                                                                        {options.map(option => (
                                                                                                            <div
                                                                                                                key={option.number}
                                                                                                                className={`drop-down-item ${selectOptionnumber === option.number ? 'active' : ''}`}
                                                                                                                style={{
                                                                                                                    pointerEvents:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? "none"
                                                                                                                            : "auto",
                                                                                                                    opacity:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? 0.5
                                                                                                                            : 1,
                                                                                                                }}
                                                                                                                onClick={() => selectOption(option)}
                                                                                                            >
                                                                                                                <div className='drop-down-item-icon'>
                                                                                                                    <span className={`icon-color color-${option.color}`}>{option.number == '501' || option.number == '502' || option.number == '503' || option.number == '504' ? '' : option.number}</span>
                                                                                                                </div>
                                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                    <div className='form-box-section'>
                                                                                                        {
                                                                                                            selectedOptionsId == '501' ? (
                                                                                                                <button
                                                                                                                    className="btn btn-primary btn-create"
                                                                                                                    disabled
                                                                                                                >
                                                                                                                    <span>Update Status</span>

                                                                                                                </button>
                                                                                                            ) : (
                                                                                                                <button
                                                                                                                    className="btn btn-primary btn-create"
                                                                                                                    // onClick={closeDropdown}
                                                                                                                    onClick={() => {
                                                                                                                        // closeDropdown()
                                                                                                                        handleassignpickupstation();
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}

                                                                                                                </button>
                                                                                                            )
                                                                                                        }

                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            }

                                                                            {
                                                                                deliveryType !== 1 && <>
                                                                                    <div className='select-dropdown-build'>
                                                                                        <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}>
                                                                                            <div className='select-option-inner' onClick={!buildstatus3 ? toggleDropdown : null}>
                                                                                                <div className='select-options-icon'>
                                                                                                    <span className={`icon-color color-${getColorClass()}`}>{selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' || selectedOptionsId == '504' ? '' : selectedOptionsId}</span>
                                                                                                </div>
                                                                                                <div className='selected-option-text'>{selectedOption}</div>
                                                                                                <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                                    <i className="bi bi-chevron-down" />
                                                                                                </span>
                                                                                            </div>

                                                                                            {isOpen && (
                                                                                                <div className='option-list buildsheet-option-list'>
                                                                                                    <div className='drop-down-list'>
                                                                                                        {options.map(option => (
                                                                                                            <div
                                                                                                                key={option.number}
                                                                                                                className={`drop-down-item ${selectOptionnumber === option.number ? 'active' : ''}`}
                                                                                                                style={{
                                                                                                                    pointerEvents:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? "none"
                                                                                                                            : "auto",
                                                                                                                    opacity:
                                                                                                                        selectedOptionsIdFromBd !== "504" && typeof option.number === "number"
                                                                                                                            ? 0.5
                                                                                                                            : 1,
                                                                                                                }}
                                                                                                                onClick={() => selectOption(option)}
                                                                                                            >
                                                                                                                <div className='drop-down-item-icon'>
                                                                                                                    <span className={`icon-color color-${option.color}`}>{option.number == '501' || option.number == '502' || option.number == '503' || option.number == '504' ? '' : option.number}</span>
                                                                                                                </div>
                                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                                            </div>
                                                                                                        ))}
                                                                                                    </div>
                                                                                                    <div className='form-box-section'>
                                                                                                        {
                                                                                                            selectedOptionsId == '501' ? (
                                                                                                                <button
                                                                                                                    className="btn btn-primary btn-create"
                                                                                                                    disabled
                                                                                                                >
                                                                                                                    <span>Update Status</span>

                                                                                                                </button>
                                                                                                            ) : (
                                                                                                                <button
                                                                                                                    className="btn btn-primary btn-create"
                                                                                                                    // onClick={closeDropdown}
                                                                                                                    onClick={() => {
                                                                                                                        // closeDropdown()
                                                                                                                        handleupateprojectstatus();
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}

                                                                                                                </button>
                                                                                                            )
                                                                                                        }

                                                                                                    </div>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </div></>
                                                                            }

                                                                            <div className='select-dropdown-build'>
                                                                                <div className={`select-options-dropdown ${isOpen2 ? 'open' : ''}`}>
                                                                                    {/* <div className='select-option-inner' onClick={toggleDropdown2}> */}
                                                                                    {/* <div className='select-option-inner' onClick={!Builderid ? toggleDropdown2 : null}> */}
                                                                                    <div className='select-option-inner' onClick={() => {
                                                                                        if (!Builderid && ['Assigned', 'Building', 'Complete', 'Verified'].includes(selectedOption)) {
                                                                                            toggleDropdown2();
                                                                                        }
                                                                                    }}
                                                                                    >
                                                                                        <div className='selected-option-text'>{selectedOption2}</div>
                                                                                        <span className={`icon ${isOpen2 ? 'up' : 'down'}`}>
                                                                                            <i className="bi bi-chevron-down" />
                                                                                        </span>
                                                                                    </div>

                                                                                    {isOpen2 && (
                                                                                        <div className='option-list buildsheet-option-list'>
                                                                                            <div className='drop-down-list'>
                                                                                                {options2.map(option => (
                                                                                                    <div
                                                                                                        key={option.text}
                                                                                                        className={`drop-down-item ${selectedOption2 === option.text ? 'active' : ''}`}
                                                                                                        onClick={() => selectOption2(option)}
                                                                                                    >
                                                                                                        <div className='drop-down-item-text'>{option.text}</div>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                            <div className='form-box-section'>
                                                                                                {
                                                                                                    selectedOption2 == 'No Builder' ? (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            disabled
                                                                                                        >
                                                                                                            <span>Update Status</span>

                                                                                                        </button>
                                                                                                    ) : (
                                                                                                        <button
                                                                                                            className="btn btn-primary btn-create"
                                                                                                            // onClick={closeDropdown2}
                                                                                                            onClick={() => {
                                                                                                                handleupatebuilderstatus();
                                                                                                            }}
                                                                                                        >
                                                                                                            {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                        </button>
                                                                                                    )
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                allMakeData && allMakeData.length > 0 ? (
                                                                                    <>
                                                                                        <div className='design_hide_mobile'>
                                                                                            <BuildTab project_id={id} project_step="buildsheet" currentpagename="buildstation" buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} allMakeData={allMakeData} SinglePrescription={SinglePrescription} prescriptioncalc={prescription} />
                                                                                        </div>
                                                                                        <div className='design_show_mobile'>
                                                                                            <BuildTabBuildStation project_id={id} project_step="buildsheet" currentpagename="buildstation" buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} allmodels={allmodels} remortFittingFormData={remortFittingFormData} nonEmptyStagingStation={nonEmptyStagingStation} allMakeData={allMakeData} dropdowndata={options} BuildStations={BuildStations} dropdowndata2={options2} buildsheetnumber={buildsheetnumber} prescriptioncalc={prescription} SinglePrescription={SinglePrescription} BuildStation={BuildStation} />
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <></>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </>
                            )
                        }

                        {/* Driver + Wood Modal Start Here */}
                        <Modal size="lg" show={show01} id="success_tic" centered className=" popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose01} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <DriverWood project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Driver + Wood Modal End Here  */}

                        {/* Hybrid Modal Start Here */}
                        <Modal size="lg" show={show3} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose3} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <Hybrid project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Hybrid Modal End Here  */}

                        {/* Iron + Wedge Start Here */}
                        <Modal size="lg" show={show4} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose4} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <IronWedge project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Iron + Wedge End Here  */}

                        {/* Wedge Start Here */}
                        <Modal size="lg" show={show5} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose5} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <Wedge project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Wedge End Here  */}

                        {/* Putter Start Here */}
                        <Modal size="lg" show={show6} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose6} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <Putter project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData} />
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Putter End Here  */}
                        <style>
                            {
                                `
                                .unique .modal-dialog{
                                    max-width: 100% !important;
                                     width: 100% !important;
                                     margin: 0 !important;
                                }
                                `
                            }
                        </style>
                    </>) : (<> </>)
            }
        </>
    );
}

function getbuildStationNumber(stationName) {
    switch (stationName) {
        case "Build Station1":
            return 1;
        case "Build Station2":
            return 2;
        case "Build Station3":
            return 3;
        case "Build Station4":
            return 4;
        default:
            return 0; // or handle other cases as needed
    }
}

export default BuildStation;